enum MapActions {
  EXTENT_CHANGED = '[map] Map extent changed',
  CHANGE_ONCLICK_ACTION = '[map] Change onclick action',
  DISABLE_ONCLICK = '[map] Disable on click event',
  ENABLE_ONCLICK = '[map] Enable on click event',
  ADD_MAP_MANAGER = '[map] Add Map Manager',
  SET_BASEMAP = '[map] Set basemap',
  SET_POPUP_PROPERTIES = '[map] Set popup properties',
  SET_HARD_LOADING = '[map] Set hard loading',
  SOURCES_IMPORTED = '[map] Sources imported'
}
export default MapActions
